/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_ObjectInputs */

const en_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to object`)
};

const de_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widerspruchsrecht`)
};

const fr_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droit d'opposition`)
};

const es_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecho de oposición`)
};

const it_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto di opposizione`)
};

const nl_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht van bezwaar`)
};

const pl_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo do sprzeciwu`)
};

const fi_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeus vastustaa käsittelyä`)
};

const da_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ret til indsigelse`)
};

const sv_privacy_rights_item_object = /** @type {(inputs: Privacy_Rights_Item_ObjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rätt att invända`)
};

/**
* | output |
* | --- |
* | "Right to object" |
*
* @param {Privacy_Rights_Item_ObjectInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_object = /** @type {((inputs?: Privacy_Rights_Item_ObjectInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_ObjectInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_object(inputs)
	if (locale === "fr") return fr_privacy_rights_item_object(inputs)
	if (locale === "es") return es_privacy_rights_item_object(inputs)
	if (locale === "it") return it_privacy_rights_item_object(inputs)
	if (locale === "nl") return nl_privacy_rights_item_object(inputs)
	if (locale === "pl") return pl_privacy_rights_item_object(inputs)
	if (locale === "fi") return fi_privacy_rights_item_object(inputs)
	if (locale === "da") return da_privacy_rights_item_object(inputs)
	if (locale === "sv") return sv_privacy_rights_item_object(inputs)
	return en_privacy_rights_item_object(inputs)
});